






























































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import _ from "@/boot/lodash";

// Enums/data
import { UpmindObjectTypes } from "@/data/enums/objects";
import { DataModules } from "@/store/modules/data";
import { ProductCategoryTypes } from "@/data/enums/products";
import { ActionTypes } from "@/data/enums";

// Components
import CProdGridItem from "@/components/app/global/contractProducts/cProdGridItem.vue";
import CProdProvider from "@/components/app/global/contractProducts/cProdProvider.vue";

// Types
import { IProvisionRequest } from "@/models/provisioning";

@Component
export default class RequestLogInfo extends Vue {
  // Props

  @Prop({ required: true })
  public request!: IProvisionRequest;

  @Prop({ default: false })
  public isCPContext!: boolean;

  // Methods

  public openProvisionConfigurationModal() {
    this.$store.dispatch(
      `data/${DataModules.PROVISIONING_CONFIGURATIONS}/openManageProviderConfigurationModal`,
      {
        props: {
          configurationId: this.request.configuration_id,
          actionType: ActionTypes.UPDATE
        }
      }
    );
  }

  public openActivityLogModal() {
    this.$store.dispatch("ui/open/slideModal", {
      config: {
        component: () =>
          import(
            "@/components/app/global/timelineComponent/timelineLogModal.vue"
          ),
        props: {
          title: this.$t("_.details"),
          data: {
            ...this.request.hook_log,
            object: this.request.order_product
          }
        }
      }
    });
  }

  public showActionModal(requestAction) {
    return !_.isEmpty(_.get(requestAction, "data"));
  }

  public openViewActionFields(requestAction) {
    this.$store.dispatch(`data/${DataModules.LOGS}/openLogModal`, {
      props: {
        log: requestAction,
        title: this.$t("_.provision_request_action_data_view", {
          actionName: requestAction.action.name
        })
      }
    });
  }

  // Computed

  public get showContractProduct() {
    return (
      this.request.order_product_type === UpmindObjectTypes.CONTRACTS_PRODUCT &&
      !this.isCPContext
    );
  }

  public get showHook() {
    return !!this.request.hook_log_id;
  }

  public get showProvisionConfiguration() {
    return !!this.request.configuration_id;
  }

  public get showScheduledForDate() {
    return !!this.request.scheduled_for;
  }

  public get showDispatchedAtDate() {
    return !!this.request.dispatched_at;
  }

  public get showExecutedAtDate() {
    return !!_.get(this.request, "results.0.created_at");
  }

  public get showActions() {
    return !!this.request?.action_logs?.length;
  }

  public get showResults() {
    return _.some(this.request.results, result => {
      return !_.isEmpty(result.data);
    });
  }

  public get statusCode() {
    return this.request.status?.code;
  }

  public get actorComponent() {
    return this.$store.getters[`data/${DataModules.LOGS}/getActorComponent`](
      this.request.actor_type,
      this.request.user_id,
      this.request.actor
    );
  }

  public get contractProductComponent() {
    const contractProduct = this.request.order_product;
    const cpProduct = contractProduct?.product;

    if (!contractProduct) return "";

    return {
      name: "TimelineLogCProd",
      render: (h: CreateElement) => {
        const props = {
          contractId: contractProduct.contract_id
        };
        const categoryType = cpProduct?.category?.category_type;

        if (categoryType === ProductCategoryTypes.PRODUCT_OPTION)
          // props["productOptionId"] = this.data.object_id;
          props["productOptionId"] = contractProduct?.id;
        else if (categoryType === ProductCategoryTypes.PRODUCT_ATTRIBUTE)
          // props["productAttributeId"] = this.data.object_id;
          props["productAttributeId"] = contractProduct?.id;
        // props["productId"] = this.data.object_id;
        else props["productId"] = contractProduct?.id;

        return h(CProdProvider, {
          props: {
            ...props,
            handleLoading: false,
            onNotFound: () => {
              // Do nothing, no redirecting
            }
          },
          scopedSlots: {
            default: ({ $cProdData }) => {
              return h(CProdGridItem, {
                props: {
                  cProd: $cProdData.contractProduct,
                  clientId: $cProdData?.contract?.client_id,
                  isLoading: $cProdData.isLoading,
                  showSkeletons: !$cProdData.contractProduct
                }
              });
            }
          }
        });
      }
    };
  }
}
